export class ValidationResult {
  hasError: boolean
  messages: string[]

  constructor(messages: string[]) {
    this.messages = messages
    this.hasError = !!messages.length
  }
}
